import { render } from "./CompletedCourseList.vue?vue&type=template&id=6fd52a7c&scoped=true&ts=true"
import script from "./CompletedCourseList.vue?vue&type=script&lang=ts"
export * from "./CompletedCourseList.vue?vue&type=script&lang=ts"

import "./CompletedCourseList.vue?vue&type=style&index=0&id=6fd52a7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd52a7c"]])

export default __exports__